import { Route, Redirect } from "react-router-dom";
import authService from "../_services/authService";

export default function AgencyPrivateRoute({
	component: Component,
	children,
	render,
	...rest
}) {
	const user = authService.getCurrentUser();
	return (
		<Route
			{...rest}
			render={({ location }) =>
				user && user?.type === 2 ? (
					children
				) : (
					<Redirect
						to={{
							pathname: "/agency",
							state: { from: location },
						}}
					/>
				)
			}
		/>
	);
}
